import {LazyPanels} from 'crazyEditor/components/EditorUI/BaseUI/index';
import {showLazyPanel} from 'crazyEditor/redux/modules/panel/panel';
import React from 'react';
import {connect} from 'react-redux';
import DynamicElements from './DynamicElements';

export default connect(
  state => ({
    openedLazyPanels: state.panel.openedLazyPanels,
  }),
  {showLazyPanel}
)(function OpenedLazyPanels(props) {
  const {showLazyPanel} = props;
  const onLoad = React.useCallback(
    panelDef => {
      const {panelName} = panelDef;
      showLazyPanel(panelName);
    },
    [showLazyPanel]
  );

  const {openedLazyPanels} = props;
  return (
    <React.Fragment>
      <LazyPanels panels={openedLazyPanels} onLoad={onLoad} />
      <DynamicElements />
    </React.Fragment>
  );
});
